export const SKILLS = [
	{
		id: "Html-1",
		name: "Html",
		icon__url: "https://cdn.worldvectorlogo.com/logos/html-1.svg",
		shadowColor: "shadow-orange-700",
		shadowColorHover: "hover:shadow-orange-700",
	},
	{
		id: "Css-2",
		name: "Css3",
		icon__url: "https://cdn.worldvectorlogo.com/logos/css-3.svg",
		shadowColor: "shadow-blue-500",
		shadowColorHover: "hover:shadow-blue-700",
	},
	{
		id: "javaScript",
		name: "JavaScript",
		icon__url: "https://cdn.worldvectorlogo.com/logos/javascript-1.svg",
		shadowColor: "shadow-yellow-500",
		shadowColorHover: "hover:shadow-yellow-700",
	},
	{
		id: "Sass-9",
		name: "Sass",
		icon__url: "https://cdn.worldvectorlogo.com/logos/sass-1.svg",
		shadowColor: "shadow-pink-500",
		shadowColorHover: "hover:shadow-pink-700",
	},
	{
		id: "Bootstrap-3",
		name: "Bootstrap",
		icon__url: "https://cdn.worldvectorlogo.com/logos/bootstrap-5-1.svg",
		shadowColor: "shadow-purple-500",
		shadowColorHover: "hover:shadow-purple-700",
	},
	{
		id: "jQuery-4",
		name: "jQuery",
		icon__url: "https://cdn.worldvectorlogo.com/logos/jquery-4.svg",
		shadowColor: "shadow-blue-500",
		shadowColorHover: "hover:shadow-blue-700",
	},

	{
		id: "React-6",
		name: "React",
		icon__url: "https://cdn.worldvectorlogo.com/logos/react-2.svg",
		shadowColor: "shadow-cyan-500",
		shadowColorHover: "hover:shadow-cyan-700",
	},
	{
		id: "React-Redux-7",
		name: "Redux",
		icon__url: "https://cdn.worldvectorlogo.com/logos/redux.svg",
		shadowColor: "shadow-purple-500",
		shadowColorHover: "hover:shadow-purple-700",
	},
	{
		id: "Styled-Components-9",
		name: "Styled Components",
		icon__url: "https://cdn.worldvectorlogo.com/logos/styled-components-1.svg",
		shadowColor: "shadow-gray-500",
		shadowColorHover: "hover:shadow-gray-700",
	},
	{
		id: "Material-Ui-8",
		name: "Material-Ui",
		icon__url: "https://cdn.worldvectorlogo.com/logos/material-ui-1.svg",
		shadowColor: "shadow-blue-500",
		shadowColorHover: "hover:shadow-blue-700",
	},
	{
		id: "Tailwind CSS-9",
		name: "Tailwind CSS",
		icon__url: "https://cdn.worldvectorlogo.com/logos/tailwind-css-2.svg",
		shadowColor: "shadow-cyan-500",
		shadowColorHover: "hover:shadow-cyan-700",
	},
	{
		id: "GulpJs-5",
		name: "Gulp Js",
		icon__url: "https://cdn.worldvectorlogo.com/logos/gulp.svg",
		shadowColor: "shadow-red-500",
		shadowColorHover: "hover:shadow-red-700",
	},
	{
		id: "Git-8",
		name: "Git",
		icon__url: "https://cdn.worldvectorlogo.com/logos/git.svg",
		shadowColor: "shadow-orange-500",
		shadowColorHover: "hover:shadow-orange-700",
	},
	{
		id: "Github-5",
		name: "Github ",
		icon__url: "https://cdn.worldvectorlogo.com/logos/github-icon.svg",
		shadowColor: "shadow-gray-500",
		shadowColorHover: "hover:shadow-gray-700",
	},
];
